'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {annexModel} from './annexmodel.js';
import {attachmentModel} from './attachmentmodel.js';

export class invitationModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'opening':
			case 'created':
			case 'updated':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
			case 'deadline':
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'fund_rate':
				return this.s('$filter')('suffix')(this[name], ' %');
			case 'budget':
			case 'min_amount':
			case 'max_amount':
			case 'applications_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'status':
			case 'stage':
			case 'change_state':
				return this.getTitledValue(name);
			case 'min_duration':
			case 'max_duration':
				return this.getOnValue(name);
			case 'duration_extension':
			case 'limit_applications':
				return this.getClassifValue(name, 'yesno');
			case 'grant_form':
				return this.getClassifValue(name, 'grant_form');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
	afterSetup(data){
		if(this.hasAnnexes()){
			let annexes = [];
			for(let annex of this.annexes){
				annexes.push(new annexModel(annex, this.s('$filter'), this.s('jsDataService')));
			}
			this.annexes = annexes;
		}
		
		if(this.hasAttachments()){
			let attachments = [];
			for(let attachment of this.attachments){
				attachments.push(new attachmentModel(attachment, this.s('$filter'), this.s('jsDataService')));
			}
			this.attachments = attachments;
		}
		this.makeCetField('deadline');
		this.makeCetField('opening');
		this.opening_cet?.setHours(12);
	}
	
	hasOptionalFields(sectionName){
		if(typeof(this.optional_fields[sectionName]) !== 'undefined' && this.optional_fields[sectionName].length > 0){
			return true;
		}
		return false;
	}
	
	getOptionalFields(sectionName){
		if(!this.hasOptionalFields(sectionName)){
			return null;
		}
		return this.optional_fields[sectionName];
	}
	
	hasAnnexes(){
		if(typeof(this.annexes) !== 'undefined' && this.annexes.length > 0){
			return true;
		}
		return false;
	}
	
	hasAttachments(){
		if(typeof(this.attachments) !== 'undefined' && this.attachments.length > 0){
			return true;
		}
		return false;
	}
}